import { LabelRadioBox } from 'components/customComponents/Layers/InputGroups';
import React from 'react';
import { useFindDropContext } from '../FindDropContext';
import { FIND_DROP_SCORES_FILTER } from './constants';
import HitsFilter from './HitsFilter';
import ScoresFilter from './ScoresFilter';
import { IStyle } from 'Styles';

const ScoringFilters = () => {
  const { scoreFilterBy, setScoreFilterBy, setHighlightedScoreWells } =
    useFindDropContext();

  return (
    <div className="flex flex-col px-[10px] gap-x-1 my-2">
      <div className="flex flex-row">
        <div className="w-[30%]">Filter Score By</div>
        <div className="flex flex-row w-[70%] gap-x-5">
          <LabelRadioBox
            labelText={'By Score'}
            name={'byScore'}
            onChange={() => {
              setScoreFilterBy(FIND_DROP_SCORES_FILTER.BY_SCORE);
            }}
            radioValue={scoreFilterBy === FIND_DROP_SCORES_FILTER.BY_SCORE}
            style={styles.radioButton}
          />
          <LabelRadioBox
            labelText={'By Hits'}
            name={'byScore'}
            onChange={() => {
              setScoreFilterBy(FIND_DROP_SCORES_FILTER.BY_HITS);
            }}
            radioValue={scoreFilterBy === FIND_DROP_SCORES_FILTER.BY_HITS}
            style={styles.radioButton}
          />
        </div>
      </div>

      {scoreFilterBy === FIND_DROP_SCORES_FILTER.BY_HITS && (
        <HitsFilter onHighlightedWells={setHighlightedScoreWells} />
      )}
      {scoreFilterBy === FIND_DROP_SCORES_FILTER.BY_SCORE && <ScoresFilter />}
    </div>
  );
};

const styles: IStyle = {
  radioButton: {
    display: 'flex',
    alignItems: 'center',
  },
};

export default ScoringFilters;
